import { CircularProgress } from "@material-ui/core";
import React, { Component, createContext, useContext } from "react";
import { db } from "../config/Firebase";
const SumContext = createContext();

export const useSum = () => useContext(SumContext);
const values = ["sum"];
class State {
  constructor(values) {
    values.forEach((el) => {
      this[el] = [];
      this[`${el}Loaded`] = false;
    });
  }
}

class SumContextProvider extends Component {
  state = {
    ...new State(values),
    sumpageLoaded: false,
    sumallLoaded: false,
  };
  getData = (type, typeLoaded) => {
    this.setState({ [typeLoaded]: false });
    const onSnapshot = (snapShot) => {
      const data = [];
      snapShot.forEach((doc) => {
        data.push(doc);
      });

      this.setState({
        [type]: data,
        [typeLoaded]: true,
      });
    };
    db.collection(type).onSnapshot(onSnapshot);
  };
  componentDidMount() {
    values.map((el) => this.getData(el, el + "Loaded"));
    window.addEventListener("load", () =>
      this.setState({ sumpageLoaded: true })
    );
  }
  UNSAFE_componentWillUpdate(prevProps, prevState) {
    const { sumpageLoaded, sumallLoaded } = prevState;
    // debugger;

    if (
      !values.map((el) => prevState[`${el}Loaded`]).includes(false) &&
      //   sumpageLoaded &&
      !sumallLoaded
    ) {
      setTimeout(() => this.setState({ sumallLoaded: true }), 100);
    }
  }
  get = (a) => a.current.value;
  render() {
    return (
      <SumContext.Provider
        value={{ ...this.state, get: this.get, getData: this.getData }}
      >
        {/* {this.props.children} */}
        {this.state.sumallLoaded ? (
          this.props.children
        ) : (
          <div
            style={{ minHeight: `100vh` }}
            className="d-flex justify-content-center align-items-center"
          >
            <div className="loader"><CircularProgress /></div>
          </div>
        )}
      </SumContext.Provider>
    );
  }
}

export default SumContextProvider;
